export let contactSheet = {
	defaultEngine: 'java',
	defaultTemplates: {
		'1x1': {
			maxAttributes: 10,
		},
		'2x2': {
			maxAttributes: 5,
		},
		'3x3': {
			maxAttributes: 3,
		},
	},
};

export const ignoreDownloadWarningTypes = ['contactSheet', 'metadata'];

export let types = {
	original: 'original',
	proxy: 'proxy',
	assetView: 'assetView',
	presetProcess: 'presetProcess',
	historical: 'historical',
	metadata: 'metadata',
	contactSheet: 'contactSheet',
	thumb: 'thumb',
	templateCustomization: 'templateCustomization',
	preview: 'preview',
	'1x1': '1x1',
	'2x2': '2x2',
	'3x3': '3x3',
};

export default {contactSheet, ignoreDownloadWarningTypes, types};
